import { render, staticRenderFns } from "./ContentTagBadges.vue?vue&type=template&id=6ca2a222&scoped=true&"
import script from "./ContentTagBadges.vue?vue&type=script&lang=js&"
export * from "./ContentTagBadges.vue?vue&type=script&lang=js&"
import style0 from "./ContentTagBadges.vue?vue&type=style&index=0&id=6ca2a222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2a222",
  null
  
)

export default component.exports